// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3y1st","rootNoMargin":"styles_rootNoMargin__2UVWL"};